var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{attrs:{"close":_vm.canBeClosed,"color":_vm.color},on:{"click:close":function($event){return _vm.onCloseEvent(_vm.itemId)}}},[_c('morphology-rule-avatar',{attrs:{"avatar":_vm.avatar}}),_vm._v(" "+_vm._s(_vm.item.text)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }